module.exports = __webpack_public_path__ + "static/media/scrap.ed7c7c83.PNG";